var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"images-loaded",rawName:"v-images-loaded:on.progress",value:(_vm.imageProgress),expression:"imageProgress",arg:"on",modifiers:{"progress":true}}],staticClass:"gallery"},[(!_vm.loadingQuery)?[_c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('Loading',{attrs:{"progress":_vm.progress}}):_vm._e()],1),_vm._l((_vm.images),function(ref,i){
var slug = ref.slug;
var acf_shooting = ref.acf_shooting;
return _c('HomeGalleryImage',{key:i,class:((acf_shooting.thumbnailShooting.categories.nodes
          .map(function (ref) {
                    var slug = ref.slug;

                    return slug;
})
          .join(' ')) + " " + slug),attrs:{"src":acf_shooting.thumbnailShooting.sourceUrl,"srcset":acf_shooting.thumbnailShooting.srcSet,"alt":acf_shooting.thumbnailShooting.altText,"active":i < _vm.n}})})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }